import script from "./SessionLockOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionLockOverlay.vue?vue&type=script&setup=true&lang=js"

import "./SessionLockOverlay.vue?vue&type=style&index=0&id=0c97b810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c97b810"]])

export default __exports__